<template>
  <section id="all-orders-listing" class="all-cases-view">
    <div class="navbarComponent">
      <div class="container-default">
        <div class="listings-navbar">
          <el-row>
            <el-col :lg="7">
              <ul class="d-flex list-items-group-15 barcode-print">
                <li>
                  <div class="form-element input-with-icon search-input-lg">
                    <el-input
                      placeholder="Search"
                      v-model="search_string"
                      @input="getAutoCompleteOrders()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :lg="17">
              <ul
                class="d-flex flex-wrap justify-content-end list-items-group-15"
              >
                <li>
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="searchBy"
                      clearable
                      filterable
                      default-first-option
                      :reserve-keyword="false"
                      placeholder="Search"
                      @change="clearInputSearch"
                    >
                      <el-option
                        v-for="item in searchOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>

                <li v-if="searchBy == 'Patient DOB'">
                  <div class="search-with-date-input">
                    <el-date-picker
                      format="MM-DD-YYYY"
                      v-model="date_of_birth"
                      :disabled-date="disabledDate"
                      @change="fetchOrders()"
                      placeholder="Select DOB"
                      :clearable="true"
                    ></el-date-picker>
                  </div>
                </li>
                <li v-else-if="searchBy == 'hospital'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="hospital"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      @change="handleCurrentChange(1)"
                      @focus="fetchAllHospitals"
                      :loading="hospitalsLoading"
                    >
                      <el-option
                        v-for="hospital in hospitalsData.data"
                        :key="hospital"
                        :label="hospital.name"
                        :value="hospital._id"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'ordering_physician'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="physician"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      @change="handleCurrentChange(1)"
                      @focus="fetchAllPhysicians"
                      :loading="physiciansLoading"
                    >
                      <el-option
                        v-for="physician in physiciansData.data"
                        :key="physician"
                        :label="physician.name"
                        :value="physician._id"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'case_types'">
                  <div
                    class="form-element search-with-filter-input"
                    v-if="
                      getAuthenticatedUser.user_type == 'LAB_TECHNOLOGIST' &&
                      getAuthenticatedUser.allowed_case_types
                    "
                  >
                    <el-select
                      v-model="caseType"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      :reserve-keyword="false"
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="caseType in getUserBasedCaseTypes(caseTypes)"
                        :key="caseType"
                        :label="caseType.label"
                        :value="caseType.value"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                  <div class="form-element search-with-filter-input" v-else>
                    <el-select
                      v-model="caseType"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      :reserve-keyword="false"
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="caseType in getLabBasedCaseTypes(caseTypes)"
                        :key="caseType"
                        :label="caseType.label"
                        :value="caseType.value"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="container-default" style="padding-top: 0">
      <div class="primary-content-view-new" v-loading="loading">
        <div class="listings listings__table listings__all-cases">
          <el-table
            :data="getAllOrders.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
          >
            <el-table-column
              label="ORDER ID"
              prop="order_id"
              sortable="custom"
              min-width="180"
              fixed="left"
            >
              <template #default="scope">
                <div class="name-accession cursor">
                  <span
                    id="accession-no-cursor"
                    @click="goToOrdersView(scope.row._id)"
                  >
                    {{ scope.row.order_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              min-width="135px"
              fixed="left"
              prop="case_types"
              sortable="custom"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}

                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                        >
                          {{ caseType }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div v-else class="case-type">
                  <span class="case-data-type">
                    {{ getCaseTypes(scope.row.case_types)[0] }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="PATIENT NAME"
              prop="patient_info.first_name"
              min-width="220"
              fixed="left"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.patient_info">
                  <el-button
                    placement="top"
                    class="title-on-hover"
                    :title="convertToUppercase(getPatientNameByInfo(scope.row.patient_info))"
                    @click="
                      copyTitle(getPatientNameByInfo(scope.row.patient_info))
                    "
                  >
                    <span class="text-center ordering_facility-value">{{
                      convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                    }}</span>
                  </el-button>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="PATIENT DOB"
              prop="date_of_birth"
              min-width="120"
            >
              <template #default="scope">
                <span
                  v-if="
                    scope.row.patient_info &&
                    scope.row.patient_info.date_of_birth
                  "
                >
                  {{ formatDate(scope.row.patient_info.date_of_birth) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="ORDERING FACILITIES"
              prop="ordering_facility"
              min-width="300"
            >
              <template #default="scope">
                <span
                  class="ordering_facility-value"
                  v-if="scope.row.hospital && scope.row.hospital.name"
                >
                  {{ scope.row.hospital.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="PHYSICIAN" prop="physician" min-width="200">
              <template #default="scope">
                <span
                  class="ordering_facility-value"
                  v-if="
                    scope.row.ordering_physician &&
                    scope.row.ordering_physician.name
                  "
                >
                  {{
                    /* scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes("Dr")
                        ? scope.row.ordering_physician.name
                        : "Dr " + scope.row.ordering_physician.name
                      : "--" */
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name
                      : "--"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="CREATED ON"
              prop="created_at"
              min-width="130"
            >
              <template #default="scope">
                <div v-if="scope.row.created_at" class="d-flex">
                  <div class="date pr-10">
                    {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy") }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Status"
              min-width="140"
              prop="status"
              sortable="custom"
            >
              <template #default="scope">
                <div class="column-status">
                  <span class="el-dropdown-link" v-if="scope.row.status">
                    <el-tag :type="getStatusType(scope.row.status)">{{
                      scope.row.status
                    }}</el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="ACCESSION ID"
              prop="accession_id"
              min-width="160"
              sortable="custom"
            >
              <template #default="scope">
                <template v-if="scope.row.case_id">
                  <div class="name-accession">
                    <span
                      id="accession-id-blue"
                      class="cursor"
                      @click="goToCaseView(scope.row.case_id)"
                    >
                      {{ scope.row.accession_id }}
                    </span>
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              width="90"
              fixed="right"
            >
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li>
                    <el-button
                      class="view-button"
                      @click="goToOrdersView(scope.row._id)"
                      title="View Order"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li v-if="hasPermission('cases', 'restore')">
                    <el-button
                      class="view-button"
                      @click="onRestore(scope.row)"
                      title="Restore Order"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/restore-icon-danger.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/restore-icon-danger.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
                <el-row> </el-row>
              </template>
            </el-table-column>
          </el-table>

          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[25, 50, 75, 100]"
              layout=" prev, pager, next, jumper, sizes ,total"
              :total="getAllOrders.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import caseConstants from "@/config/constants/caseConstants";
import FilterHelper from "@/mixins/FilterHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import { ordersSearchOptions } from "@/config/constants/searchConstants";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
export default {
  data() {
    return {
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      scrollPosition: null,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      searchOptions: ordersSearchOptions,
      // searchByKey: ["PatientName", "order_id", "EMR"],
      page: 1,
      pageSize: 25,
      loading: false,
      search_string: "",
      searchBy: "",
      orderBy: "created_at",
      orderType: "DESC",
      hospital: "",
      physician: "",
      date_of_birth: "",
      caseType: "",
      hospitalsData: {},
      physiciansData: {},
      hospitalsLoading: false,
      physiciansLoading: false,
    };
  },
  mixins: [FilterHelper, caseDataHelper, UserPermissionsHelper],
  computed: {
    ...mapGetters("orders", [
      "getAllOrders",
      "getRestoreOrderStatus",
      "getRestoreOrderError",
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else {
          return "";
        }
      };
    },

    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
  },
  async mounted() {
    this.setQueryParamsData();
    await this.fetchOrders();
  },
  methods: {
    async fetchAllPhysicians() {
      this.physiciansLoading = true;
      await this.$store.dispatch("physicians/fetchAllPhysicians", {
        get_all: true,
      });
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
      this.physiciansLoading = false;
    },
    async fetchAllHospitals() {
      this.hospitalsLoading = true;
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      this.hospitalsLoading = false;
    },

    clearInputSearch() {
      if (
        this.hospital ||
        this.physician ||
        this.date_of_birth ||
        this.caseType
      ) {
        this.hospital = "";
        this.physician = "";
        this.date_of_birth = "";
        this.caseType = "";
        this.isSearchByInput = "";
        this.page = 1;
        this.fetchOrders(1);
      }
    },
    getAutoCompleteOrders() {
      setTimeout(() => {
        this.page = 1;
        this.fetchOrders();
      }, 600);
    },
    async onRestore(order) {
      this.$confirm("Are you sure to Restore order?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.restoreOrder(order);
      });
    },

    async restoreOrder(order) {
      this.loading = true;
      let params = {
        order_id: order._id,
        status: order.accession_id ? "COMPLETE" : "ACTIVE",
      };
      await this.$store.dispatch("orders/restoreArchivedOrder", params);
      if (this.getRestoreOrderStatus) {
        successNotification("Order Restored Successfully");
        await this.fetchOrders(this.page);
      } else {
        errorNotification(
          this.getRestoreOrderError || "An Error occured while restoring."
        );
      }
      this.loading = false;
    },
    goToOrdersView(orderId) {
      this.$router.push({
        name: "Order-Information",
        params: { order_id: orderId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    goToCaseView(caseId) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: caseId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "created_at";
        this.orderType = "DESC";
      }
      this.fetchOrders();
    },
    setQueryParamsData() {
      if (this.$route.query) {
        this.page = this.$route.query.selectedOrderPage
          ? parseInt(this.$route.query.selectedOrderPage)
          : 1;
        this.pageSize = this.$route.query.selectedOrderPageSize
          ? parseInt(this.$route.query.selectedOrderPageSize)
          : 25;
        if (this.$route.query.selectedOrderString) {
          this.search_string = this.$route.query.selectedOrderString;
        }
        if (this.$route.query.selectedOrderCase) {
          this.caseType = this.$route.query.selectedOrderCase;
        }
        if (this.$route.query.selectedOrderSearchBy) {
          this.searchBy = this.$route.query.selectedOrderSearchBy;
        }
        if (this.$route.query.selectedOrderPhysician) {
          this.physician = this.$route.query.selectedOrderPhysician;
        }
        if (this.$route.query.selectedOrderHospital) {
          this.hospital = this.$route.query.selectedOrderHospital;
        }
        if (this.$route.query.selectedOrderDateOfBirth) {
          this.date_of_birth = this.$route.query.selectedOrderDateOfBirth;
        }
        if (this.$route.query.selectedOrderOrderBy) {
          this.orderBy = this.$route.query.selectedOrderOrderBy;
        }
        if (this.$route.query.selectedOrderOrderType) {
          this.orderType = this.$route.query.selectedOrderOrderType;
        }
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchOrders();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchOrders();
    },

    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
        status: ["ARCHIVED"],
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.date_of_birth) {
        const date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");

        params.date_of_birth = date_of_birth;
      }
      if (this.hospital) {
        params.hospital = this.hospital;
      }
      if (this.caseType) {
        params.case_type = this.caseType;
      }
      if (this.physician) {
        params.ordering_physician = this.physician;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      return params;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedOrderPage: params.page,
        selectedOrderCase: params.case_type,
        selectedOrderHospital: params.hospital,
        selectedOrderDateOfBirth: params.date_of_birth,
        selectedOrderPhysician: params.ordering_physician,
        selectedOrderString: params.search_string,
        selectedOrderPageSize: params.limit,
        selectedOrderOrderBy: params.order_by,
        selectedOrderOrderType: params.order_type,
        selectedOrderSearchBy: this.searchBy || undefined,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    async fetchOrders() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("orders/getOrders", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss">
#all-orders-listing {
  .stickyNavbar {
    padding-bottom: 5px !important;
    .container-default {
      padding-top: 0;
      padding-bottom: 5px;
    }
  }
  .listings__table {
    .name-accession {
      display: inline-block;
      overflow: hidden;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    #accession-id {
      color: #eb5757;
      cursor: pointer;
    }
    #patient-name {
      overflow: hidden;
      margin-left: 7px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
